import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=80a36316&scoped=true&"
import script from "./Customize.vue?vue&type=script&lang=js&"
export * from "./Customize.vue?vue&type=script&lang=js&"
import style0 from "./Customize.vue?vue&type=style&index=0&id=80a36316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a36316",
  null
  
)

export default component.exports